import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'documentTypePipe'})
export class DocumentTypePipe implements PipeTransform {
  transform(items: any[], search: any): any[] {
    if(!items) return [];
    if(!search) return items;
    return items.filter( item => {
      if(search.logic == 'include') {
        return (search.terms.indexOf(item.type.toLowerCase()) > -1);
      }
      if(search.logic == 'exclude') {
        return !(search.terms.indexOf(item.type.toLowerCase()) > -1);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/document.pipe.ts